import React from 'react'

export default function Download() {
    return (
        <div>
            <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.7499 4.16667H31.2499V6.25H18.7499V4.16667ZM31.2499 2.08333V0H18.7499V2.08333H31.2499ZM20.5291 45.8333L16.6666 50H33.3333L29.4708 45.8333H20.5291ZM41.6666 16.6667H31.2499V8.33333H18.7499V16.6667H8.33325L24.9999 33.3333L41.6666 16.6667ZM37.4999 39.5833H12.4999V26.725L8.33325 22.5583V43.75H41.6666V22.5583L37.4999 26.725V39.5833Z" fill="#BB0600" />
            </svg>

        </div>
    )
}
